import { Notification } from '@talend/react-containers';

import {
	SET_CAD_FORM_DATA,
	SEND_CAD_FORM_NOTIFICATION,
	SET_CAD_FORM_BEGIN_LOADING,
	SET_CAD_FORM_STOP_LOADING,
} from './CADForm.constants';

export const INITIAL_STATE = {
	loading: false,
};

export default function (
	store = INITIAL_STATE,
	{ type, payload }: { type: string; payload?: any },
): any {
	switch (type) {
		case SET_CAD_FORM_DATA:
			return { ...store, data: payload };
		case SET_CAD_FORM_BEGIN_LOADING:
			return { ...store, loading: true };
		case SET_CAD_FORM_STOP_LOADING:
			return { ...store, loading: false };
		case SEND_CAD_FORM_NOTIFICATION:
			Notification.push(payload.state, payload);
			return store;
		default:
			return store;
	}
}
